import { NgModule } from '@angular/core';

import { MgAvatarModule } from '@app/src/app/elements/MgAvatar';

import { StudentPictureModule } from '@shared/directives/student-picture/student-picture.module';
import { CommonUIModules } from '@shared/modules';

import { UserProfileHeaderComponent } from './user-profile-header.component';

@NgModule({
  imports: [
    // Common modules
    CommonUIModules,

    // Minga dependencies
    MgAvatarModule,
    StudentPictureModule,

    // External dependencies
  ],
  declarations: [UserProfileHeaderComponent],
  exports: [UserProfileHeaderComponent],
})
export class UserProfileHeaderModule {}
